module.exports = __webpack_public_path__ + "static/02-bef8d9227946c84c256d46faf42f7c02.jpg";